module.exports = __webpack_public_path__ + "saira-medium-webfont.6ae0b8217d3f2a4cfea7.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-medium-webfont.woff2
// module id = ../../../../../src/assets/fonts/saira-medium-webfont.woff2
// module chunks = styles